import { Injectable, inject } from '@angular/core';
import { Observable, tap } from 'rxjs';

import { ApiRequestService } from '../api-request/api.request.service';

import { UserDTO } from './models/user-dto.model';
import { UserService } from '../user/user.service';
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private _apiService = inject(ApiRequestService);
  private _userService = inject(UserService);

  public getUser(emailAddress: string): Observable<UserDTO> {
    return this._apiService.get$<UserDTO>(
      `/api/v1/Auth/Login?emailAddress=${emailAddress}`,
    ).pipe(
      tap((user: UserDTO) => this._userService.setUser(user))
    );
  }
}
